module.exports = __webpack_public_path__ + "static/data_bar_4-cbba00d8a6876f3752a2a16e4fc0a658.png";